import React, { useState, useEffect } from "react";
import "./navbar.css";
import charamyLogo from "../../images/charamylogo.jfif";
import { useHistory, useLocation } from "react-router-dom";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close menu when route changes
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isMenuOpen]);

  const goTo = (path) => {
    setIsMenuOpen(false);
    history.push(path);
  };

  const scrollToSection = (sectionId) => {
    setIsMenuOpen(false);
    
    // Agar blogs page pe ho to pehle home pe jao
    if (location.pathname === "/blogs") {
      history.push("/");
      // Thoda delay do taki page load ho jaye
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    } else {
      // Home page pe ho to direct scroll karo
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <nav className={`navbar ${isScrolled ? "scrolled" : ""}`}>
        <div className="navbar-container">
          {/* Logo */}
          <div
            className="navbar-logo"
            onClick={() => goTo("/")}
            style={{ cursor: "pointer" }}
          >
            <img
              src={charamyLogo}
              alt="Charamy Logo"
              className="logo-image"
            />
            <span className="logo-text">Charamy</span>
          </div>

          {/* Desktop Menu */}
          <div className="navbar-menu desktop-menu">
            <span onClick={() => scrollToSection("about")} className="menu-item">
              About
            </span>
            <span onClick={() => scrollToSection("how-it-works")} className="menu-item">
              How It Works
            </span>
            <span onClick={() => scrollToSection("services")} className="menu-item">
              Services
            </span>
            <span onClick={() => scrollToSection("case-studies")} className="menu-item">
              Case Studies
            </span>
            <span onClick={() => scrollToSection("pricing")} className="menu-item">
              Pricing
            </span>
            <span onClick={() => scrollToSection("contact")} className="menu-item">
              Contact Us
            </span>
            <span onClick={() => goTo("/blogs")} className="menu-item">
              Blogs
            </span>
          </div>

          {/* CTA Button */}
          <span
            onClick={() => scrollToSection("contact")}
            className="navbar-cta"
          >
            Contact Us
          </span>

          {/* Hamburger Menu Button */}
          <button 
            className={`hamburger ${isMenuOpen ? "active" : ""}`}
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      <div className={`mobile-menu-overlay ${isMenuOpen ? "active" : ""}`}>
        <div className={`mobile-menu ${isMenuOpen ? "active" : ""}`}>
          <div className="mobile-menu-items">
            <span onClick={() => scrollToSection("about")} className="mobile-menu-item">
              About
            </span>
            <span onClick={() => scrollToSection("how-it-works")} className="mobile-menu-item">
              How It Works
            </span>
            <span onClick={() => scrollToSection("services")} className="mobile-menu-item">
              Services
            </span>
            <span onClick={() => scrollToSection("case-studies")} className="mobile-menu-item">
              Case Studies
            </span>
            <span onClick={() => scrollToSection("pricing")} className="mobile-menu-item">
              Pricing
            </span>
            <span onClick={() => scrollToSection("contact")} className="mobile-menu-item">
              Contact Us
            </span>
            <span onClick={() => goTo("/blogs")} className="mobile-menu-item">
              Blogs
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;